/* rb-b-sizeclean.js — tidy the Size facet on the customer's end only.

   RUNS EVERYWHERE, DESKTOP AND MOBILE, since 10 Sep — and the history matters
   because this file has been on both sides of that question.

   It originally had NO breakpoint gate, which broke Mark's "mobile should be
   exactly as it is on the live site": at 430px it was stamping data-rbb-sized
   on all 100 rows, hiding 29 of them and moving the One Size chip, while live
   showed the untouched list. A 981px gate was added.

   The gate is now gone again, deliberately and with Mark's sign-off after he
   saw the before/after. What changed is the reasoning, not the rule: "mobile
   matches live" was about the desktop PANEL — the sticky column, the shifted
   grid, the injected Shop block. This module is pure list cleanup. It injects
   no markup, needs no CSS, and the mobile drawer renders the identical
   .collection-sidebar markup, so it simply works there. Measured on mobile:
   /collections/footwear 21 visible size rows -> 8; /collections/all 100 -> 56.

   STILL GATED, and not by accident: rb-b-pants.js. Its waist/inseam control is
   built markup that needs styling before it belongs in the drawer, so the wXi
   combos and the plain waist list are still raw on mobile. That is the next
   piece of work, not an oversight.

   CHANGES NOTHING IN SHOPIFY. It hides and regroups rows the theme already
   rendered, and drives the theme's own checkboxes when a merged row is
   clicked. Duplicate pills in the results bar are handled by rb-b-pills.js.

   HOW THE LIST IS BUILT (matters for everything below):
   one <ul> with subheading ROWS inside it — li.collection-sidebar__size-subheader
   (Traditional Sizes, Pant Sizes, Waist Sizes, Shoe Sizes, Container, One
   Size, Misc) followed by li.collection-sidebar__item rows until the next
   subheader. There is no wrapper element per bucket, so a bucket is whatever
   sits between two subheaders. That is why this walks siblings.

   WHAT IT DOES
     1. Hides values that are not sizes: 3 oz, 9 mm, 0.56oz, eyewear frame
        specs like 54/19-145, DEFAULT, HARDCOVER, PAPERBACK. On /collections/all
        that is 22 of the 100 rendered rows.
     2. Merges duplicate spellings — 'S 1' folds into 'Small 286', 'XL 3' into
        'X- Large 834'. Clicking the survivor ticks every underlying checkbox
        and fires ONE change, so Shopify returns the union.
     3. Folds the One Size bucket (Classic, O/S, One Size, Regular) into a
        single 'One size' chip and moves it into Traditional Sizes.
     4. Removes any subheading left with nothing visible under it.

   WHAT IT CANNOT FIX — say this plainly. Shopify caps a filter at 100 VALUES
   server-side, before the page is rendered. The Size axis carries 112, so 12
   are already absent from the HTML when this runs. Tidying makes the list
   readable; it does NOT bring those back. Only fixing the catalog does.

   Re-runs after each AJAX filter change, like everything else here. */

(function () {
  'use strict';

  /* MOBILE PARITY GUARD — see the note at the top. */
  /* GATE REMOVED 10 Sep — this now runs on mobile as well. See the header
     note, which has been corrected: the "mobile identical to live" rule was
     about the desktop panel layout, and this module is pure list cleanup with
     no markup and no CSS of its own. */

  var UNITS = /(^|\s|\d)(oz|ml|mm|cm|liter|litre)\b/i;
  var FRAME = /^\d{2}\/\d{2}-\d{2,3}$/;          // 54/19-145
  var TEMPLE = /^\d{2}[ML]$/i;                    // 57M, 59L
  var PLACEHOLDER = /^(default|default title|hardcover|paperback)$/i;

  /* Everything that really means "one size". Classic and Regular are fit words
     used as sizes on a handful of products; they are not a size choice a
     shopper makes, so they fold in with O/S. */
  var ONE_SIZE = /^(one size|one size fits most|o\/s|os|osfm|classic|regular)$/i;

  function isNotASize(label) {
    var s = (label || '').trim();
    return UNITS.test(s) || FRAME.test(s) || TEMPLE.test(s) || PLACEHOLDER.test(s);
  }

  function norm(v) {
    var s = (v || '').trim().toLowerCase();
    if (ONE_SIZE.test(s)) return 'onesize';
    s = s.replace(/[\s\-_]+/g, '');
    s = s.replace(/extra/g, 'x');
    if (/^0\d+$/.test(s)) s = s.replace(/^0+/, '') || '0';
    var canon = {
      small: 's', medium: 'm', large: 'l',
      xsmall: 'xs', xlarge: 'xl', xxlarge: 'xxl', xxxlarge: 'xxxl'
    };
    return canon[s] || s;
  }

  function rowLabel(row) {
    var el = row.querySelector('.collection-sidebar__link');
    if (!el) return '';
    var clone = el.cloneNode(true);
    var c = clone.querySelector('.collection-sidebar__link__count');
    if (c) c.remove();
    return clone.textContent.trim().replace(/\s+/g, ' ');
  }

  function rowCount(row) {
    var c = row.querySelector('.collection-sidebar__link__count');
    var n = c ? parseInt((c.textContent || '').replace(/[^\d]/g, ''), 10) : NaN;
    return isNaN(n) ? 0 : n;
  }

  function setLabel(row, text) {
    var link = row.querySelector('.collection-sidebar__link');
    if (!link) return;
    var replaced = false;
    Array.prototype.forEach.call(link.childNodes, function (n) {
      if (n.nodeType === 3 && n.textContent.trim()) {
        n.textContent = replaced ? '' : text;
        replaced = true;
      }
    });
  }

  function isSubhead(el) {
    return el && el.classList && el.classList.contains('collection-sidebar__size-subheader');
  }

  function clean() {
    var grp = document.querySelector('.collection-sidebar__filter-group--size');
    if (!grp) return;
    var ul = grp.querySelector('.collection-sidebar__items');
    if (!ul) return;

    var rows = Array.prototype.slice.call(ul.querySelectorAll('.collection-sidebar__item'));
    if (!rows.length) return;

    var groups = {};

    rows.forEach(function (row) {
      if (row.dataset.rbbSized === '1') return;
      row.dataset.rbbSized = '1';

      var label = rowLabel(row);
      var input = row.querySelector('input');
      var checked = !!(input && input.checked);

      // Never hide something the shopper has applied — they could not remove it.
      if (isNotASize(label) && !checked) {
        row.style.display = 'none';
        row.dataset.rbbHidden = 'junk';
        return;
      }

      var k = norm(label);
      (groups[k] = groups[k] || []).push({ row: row, label: label, n: rowCount(row), input: input });
    });

    Object.keys(groups).forEach(function (k) {
      var set = groups[k];
      if (set.length < 2) return;

      set.sort(function (a, b) { return b.n - a.n; });
      var keep = set[0];
      var total = set.reduce(function (sum, e) { return sum + e.n; }, 0);

      var countEl = keep.row.querySelector('.collection-sidebar__link__count');
      if (countEl) countEl.textContent = total;

      var inputs = set.map(function (e) { return e.input; }).filter(Boolean);

      set.slice(1).forEach(function (e) {
        e.row.style.display = 'none';
        e.row.dataset.rbbHidden = 'merged';
      });

      // The one-size family gets one honest label instead of whichever
      // spelling happened to have the highest count.
      if (k === 'onesize') {
        setLabel(keep.row, 'One size');
        keep.row.dataset.rbbOneSize = '1';
      }

      var link = keep.row.querySelector('.collection-sidebar__link');
      if (!link || link.dataset.rbbMerged === '1') return;
      link.dataset.rbbMerged = '1';
      link.title = set.map(function (e) { return e.label + ' (' + e.n + ')'; }).join(' + ');

      link.addEventListener('click', function (ev) {
        ev.preventDefault();
        var turnOn = !inputs.some(function (i) { return i.checked; });
        inputs.forEach(function (i) { i.checked = turnOn; });
        if (inputs[0]) inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    moveOneSizeIntoTraditional(ul);
    tagTraditional(ul);
    dropEmptySubheads(ul);
  }

  /* Mark the rows under "Traditional Sizes" so CSS can lay THAT bucket out on
     its own terms. The size facet is a single flat <ul> — buckets are just
     the runs between subheading rows, with no wrapper to hang a selector on —
     so a stylesheet cannot otherwise tell a letter chip from a shoe chip, and
     rb-b-polish.css needs to give the two different treatment: numeric chips
     get a uniform 44px floor, letter chips a two-column layout, and neither
     rule can be allowed to reach the other bucket.

     Tagged HERE, and only for traditional, because this module owns that
     bucket and has just finished moving the One size chip into it. The later
     modules (rb-b-shoes at 140ms, rb-b-pants at 110ms) move numeric rows
     between the shoe and waist buckets but never move anything into or out
     of traditional, so the tag cannot go stale. */
  function tagTraditional(ul) {
    var kids = Array.prototype.slice.call(ul.children);
    var inBucket = false;
    kids.forEach(function (el) {
      if (isSubhead(el)) {
        inBucket = /traditional/i.test(el.textContent || '');
        return;
      }
      if (!el.classList || !el.classList.contains('collection-sidebar__item')) return;
      if (inBucket) el.dataset.rbbBucket = 'traditional';
      else if (el.dataset.rbbBucket === 'traditional') delete el.dataset.rbbBucket;
    });
  }

  /* Put the single One size chip at the end of Traditional Sizes so the Size
     facet reads as one list of choices rather than a run of tiny sections. */
  function moveOneSizeIntoTraditional(ul) {
    var chip = ul.querySelector('[data-rbb-one-size="1"]');
    if (!chip || chip.dataset.rbbMoved === '1') return;

    var kids = Array.prototype.slice.call(ul.children);
    var startIdx = -1;
    for (var i = 0; i < kids.length; i++) {
      if (isSubhead(kids[i]) && /traditional/i.test(kids[i].textContent || '')) { startIdx = i; break; }
    }
    if (startIdx === -1) return;

    var lastVisible = null;
    for (var j = startIdx + 1; j < kids.length; j++) {
      if (isSubhead(kids[j])) break;
      if (kids[j].style.display !== 'none') lastVisible = kids[j];
    }
    if (!lastVisible) return;

    lastVisible.parentNode.insertBefore(chip, lastVisible.nextSibling);
    chip.dataset.rbbMoved = '1';
  }

  /* A subheading with nothing visible beneath it is just a stray word. */
  function dropEmptySubheads(ul) {
    var kids = Array.prototype.slice.call(ul.children);
    kids.forEach(function (el, i) {
      if (!isSubhead(el)) return;
      var visible = 0;
      for (var j = i + 1; j < kids.length; j++) {
        if (isSubhead(kids[j])) break;
        if (kids[j].style.display !== 'none') visible++;
      }
      el.style.display = visible ? '' : 'none';
    });
  }

  function boot() {
    clean();
    var section = document.querySelector('.js-section__collection');
    if (!section || !window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(clean, 90);
    }).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
